
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/notifications",
      function () {
        return require("private-next-pages/candidate/notifications/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/notifications"])
      });
    }
  